/* eslint eqeqeq:0 */
'use strict';

class RegisterLoss {
  constructor($routeParams, $location, invoiceService, salesLedgerService) {
    this.$location = $location;
    this.invoiceService = invoiceService;
    this.salesLedgerService = salesLedgerService;

    this.invoiceNumber = $routeParams.number;
    this.paymentNumber = $routeParams.paymentNumber;
  }

  $onInit() {
    this.entries = [];
    this.balance = 0;
    this.payment = {
      amount: 0
    };
    this.invoice = {};

    // get invoice data
    this.invoiceService.get(this.invoiceNumber)
      .then((invoice) => {
        this.invoice = invoice.data;
      });

    // get sales ledger entries
    this.salesLedgerService.getInvoiceEntries(this.invoiceNumber)
      .then((resp) => {
        this.entries = resp.data;

        // get interest
        resp.data.forEach((e) => {
          if (e.number == this.paymentNumber) {
            this.payment.amount = e.amount;
          }
        }, this);
      })
      .then(() => {
        this.salesLedgerService.getInvoiceBalance(this.invoiceNumber)
          .then((resp) => {
            this.balance = resp.data.balance;
          });
      });
  }

  register() {
    this.salesLedgerService.registerLoss(this.paymentNumber,
      {
        amount: this.payment.amount
      })
      .then(() => this.$location.path(`/regning/${this.invoiceNumber}`));
  }
}

RegisterLoss.$inject = ['$routeParams', '$location', 'invoiceService', 'salesLedgerService'];

const registerLoss = {
  controller: RegisterLoss,
  template: `
    <h2>Tap av renter</h2>

    <form novalidate name="registerLostForm" ng-submit="$ctrl.register()">
      <fieldset>
        <div class="row">
          <div class="large-12 columns">
            <label for="amount">Bel&oslash;p</label>
            <div class="row collapse">
              <div class="large-9 columns">
                <input type="number" id="amount" name="amount" ng-model="$ctrl.payment.amount" required>
              </div>
              <div class="large-3 columns">
                <span class="postfix">NOK</span>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <button class="button" type="submit" ng-disabled="registerLostForm.$invalid">Registrer</button>
      <a role="button" class="button secondary" href="#/regning/{{ $ctrl.invoiceNumber }}">Avbryt</a>
    </form>

    <h3 class="subheader">Tidligere registrert på regning {{ $ctrl.invoiceNumber }}</h3>

    <table>
      <thead>
        <tr>
          <th>Dato</th>
          <th>Beskrivelse</th>
          <th class="right-align">Bel&oslash;p</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="entry in $ctrl.entries track by $index">
          <td>{{ entry.date | date:'dd.MM.yy' }}</td>
          <td>{{ entry.description }}</td>
          <td class="right-align no-wrap">{{ entry.amount | crowns }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="2">Utest&aring;ende</th>
          <th class="right-align">{{ $ctrl.balance | crowns }}</th>
        </tr>
      </tfoot>
    </table>
  `
};

angular
  .module('SendRegning')
  .component('registerLoss', registerLoss)
  .config(($routeProvider) => {
    $routeProvider
      .when('/regning/:number/renter/:paymentNumber', {
        title: 'Tap av renter',
        template: '<register-loss />',
        secure: true
      });
  });
